import { StudioFinderResultsList } from './StudioFinderResultsList'

export default StudioFinderResultsList
